module.exports = __webpack_public_path__ + "static/img/redBook.3cf4e50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/redBook.png
// module id = FSBz
// module chunks = 1